module.exports = __webpack_public_path__ + "img/rg-target-object-caution-default.45933811.svg";